const FUNCTIONARY = 17;
const PROFESSIONIST = 33;
const STUDENT = 14;
const TEACHER = 15;
const TEACHER_UNI = 25;

export const GROUPS = {
    FUNCTIONARY,
    PROFESSIONIST,
    STUDENT,
    TEACHER_UNI,
    TEACHER,
};
